import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { queryParamsToSearchParams } from '@monorepo/tools/src/lib/utils/url';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { InventoryModel } from '../models/inventory.model';

export interface IInventoryRequestParams {
	accountId: id;
	page?: number;
	pageSize?: number;
	domain?: string;
	geo?: string;
	deeplink?: string;
	clickCapMin?: string;
	clickCapMax?: string;
	commissionMin?: string;
	commissionMax?: string;
	vertical?: string;
	sortBy?: string;
	sortDir?: string;
}

export interface IInventoryListResponse {
	list: InventoryModel[];
	total: number;
	page: number;
	pageSize: number;
	hasMore: boolean;
}

export const InventoryApi = {
	list: (params: IInventoryRequestParams, options?: IRequestOptions): Promise<IInventoryListResponse> => {
		const {
			accountId,
			page = 1,
			pageSize = 1000,
			domain,
			geo,
			deeplink,
			clickCapMin,
			clickCapMax,
			commissionMin,
			commissionMax,
			vertical,
			sortBy,
			sortDir,
		} = params;
		return ask
			.get(
				endpoints.inventory.get(accountId),
				queryParamsToSearchParams({
					page,
					pageSize,
					...(domain ? { domain } : {}),
					...(geo ? { geo } : {}),
					...(deeplink ? { deeplink } : {}),
					...(clickCapMin ? { clickCapMin } : {}),
					...(clickCapMax ? { clickCapMax } : {}),
					...(commissionMin ? { commissionMin } : {}),
					...(commissionMax ? { commissionMax } : {}),
					...(vertical ? { vertical } : {}),
					...(sortBy ? { sortBy } : {}),
					...(sortDir ? { sortDir } : {}),
					...(options?.queryParams || {}),
				})
			)
			.then(res => ({
				list: res?.payload?.list ?? [],
				total: res?.payload?.total ?? 0,
				page: res?.payload?.page ?? page,
				pageSize: res?.payload?.pageSize ?? pageSize,
				hasMore: res?.payload?.hasMore ?? false,
			}));
	},

	downloadCsv: (params: IInventoryRequestParams, options?: IRequestOptions): Promise<File | null> => {
		return ask.download(
			endpoints.inventory.get(params.accountId),
			queryParamsToSearchParams({ format: 'CSV', ...(options?.queryParams || {}) })
		);
	},
};
